export default function DownloadListIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (18.993 / 17.508) : 18.993}
      height={height ? height : width ? width * (17.508 / 18.993) : 17.508}
      viewBox="0 0 18.993 17.508"
    >
      <g transform="translate(-872.789 -1345.789)">
        <path
          d="M-14166.062-19961.121h-3.918a2.027,2.027,0,0,1-2.02-2.031v-8.809a2.031,2.031,0,0,1,2.02-2.039h11.152a2.036,2.036,0,0,1,2.029,2.039v3.2h-4.652v.867a6.8,6.8,0,0,0-1.2.793v-1.66h-3.3v2.5h2.439a7.012,7.012,0,0,0-.834,1.2h-1.719v3.938Zm-4.736-4.039v2.008a.827.827,0,0,0,.818.832h2.715v-2.84Zm0-3.6v2.395h3.648v-2.395Zm.818-4.043a.832.832,0,0,0-.818.84v2h12.8v-2a.836.836,0,0,0-.828-.84Z"
          transform="translate(15044.789 21319.789)"
          fill="currentColor"
          opacity="0.7"
        />
        <g transform="translate(881.911 1353.426)">
          <path
            d="M4.635-.6A5.235,5.235,0,1,1-.6,4.635,5.241,5.241,0,0,1,4.635-.6Zm0,9.271A4.035,4.035,0,1,0,.6,4.635,4.04,4.04,0,0,0,4.635,8.671Z"
            fill="currentColor"
          />
          <path
            d="M-15051.577-21321.6h0a.6.6,0,0,1-.423-.172l-1.729-1.734a.593.593,0,0,1,0-.846.6.6,0,0,1,.846,0l.712.711v-3.184a.6.6,0,0,1,.6-.6.6.6,0,0,1,.6.6v3.186l.712-.713a.6.6,0,0,1,.852,0,.605.605,0,0,1,0,.846l-1.734,1.734a.59.59,0,0,1-.423.172Z"
            transform="translate(15056.211 21329.152)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
